const AGENTS_REQUIRED = Object.freeze({
  1: 1,
  2: 5,
  3: 10,
  4: 15,
  5: 20
})

export { AGENTS_REQUIRED }
